<particle-flow-chart-response *ngIf="data.input.section" #flowChartResponse [section]="section" [surveyId]="data.input.surveyId"
                              [sourceType]="data.input.sourceType" [rowItem]="data.input.rowItem" [fieldDefinitions]="data.input.fieldDefinitions"></particle-flow-chart-response>
